var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.10034V9.26697",
    stroke: "#FF8800",
    strokeWidth: 0.949988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50087 13.9593H4.66292C2.46528 13.9593 1.54696 12.3887 2.61094 10.4697L4.58692 6.91044L6.4489 3.56648C7.57621 1.5335 9.42552 1.5335 10.5528 3.56648L12.4148 6.91677L14.3908 10.4761C15.4548 12.395 14.5301 13.9657 12.3388 13.9657H8.50087V13.9593Z",
    stroke: "#FF8800",
    strokeWidth: 0.949988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49609 11.167H8.50178",
    stroke: "#FF8800",
    strokeWidth: 1.26665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/DangerIcon.c75d5a5c5bf4e49abf12767afb9a50f6.svg";
export { ForwardRef as ReactComponent };